<ul class="media-list media-list-divider mr-2">
  <li *ngFor="let user of topPerformers" class="media align-items-center">
    <a class="media-img" routerLink="/staff/{{user.id}}/cdetails">
      <img class="img-circle" [src]="user.profile_photo" alt="image" width="50">
      <!--ngx-avatar name="{{user.name}}" size="50" initialsSize="3" textSizeRatio="2.5"></ngx-avatar-->
    </a>
    <div class="media-body d-flex align-items-center">
      <div class="flex-1">
        <div class="text-box">
          <div class="media-heading">
            <div class="mb-1">{{ user.name }}</div>
            <small class="text-muted">{{ user.total }}</small>
          </div>
        </div>
      </div>
    </div>
  </li>
</ul>
